import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../services/apis";


export function* handleRaiseCorrectionRequest({payload}) {
  try {
    const res = yield call(API.raiseCorrectionRequest, payload);
    const { data } = res;
    yield put(actions.raiseCorrectionRequestSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.raiseCorrectionRequestFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}

export function* handleFetchCorrectionData({payload}) {
  try {
    const res = yield call(API.getCorrectionData, payload);
    const { data } = res;
    yield put(actions.fetchCorrectionDataSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchCorrectionDataFailure(err?.response?.data));
    payload.onFailure(err?.response?.data);
  }
}


export function* raisedCorrectionSaga() {
    yield takeEvery(actions.raiseCorrectionRequest.type, handleRaiseCorrectionRequest);
    yield takeLatest(actions.fetchCorrectionData.type, handleFetchCorrectionData);
}
